import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { CollaboratorProductApi } from 'api';

export const findCollaboratorProduct = createAsyncThunk(
  'collaboratorProduct/findCollaboratorProduct',
  async (option: any, { rejectWithValue }) => {
    try {
      const response = await CollaboratorProductApi.find(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface Update {
  id: string;
  body: any;
}
export const updateCollaboratorProduct = createAsyncThunk(
  'collaboratorProduct/updateCollaboratorProduct',
  async (params: Update, { rejectWithValue }) => {
    try {
      const { id, body } = params;
      const response = await CollaboratorProductApi.update(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateStatusCollaboratorProduct = createAsyncThunk(
  'collaboratorProduct/updateStatusCollaboratorProduct',
  async (params: Update, { rejectWithValue }) => {
    try {
      const { id, body } = params;
      const response = await CollaboratorProductApi.updateStatus(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface State {
  tableList: Array<any>;
  orderList: Array<any>;
  list: Array<any>;
  reloadFlag: boolean;
}

const initialState: State = {
  tableList: [],
  orderList: [],
  list: [],
  reloadFlag: false,
};

const productSlice = createSlice({
  name: 'collaboratorProduct',
  initialState,
  reducers: {
    reloadCollaboratorProduct(state) {
      state.reloadFlag = !state.reloadFlag;
    },
  },
  extraReducers: builder => {
    builder.addCase(findCollaboratorProduct.fulfilled, (state, action) => {
      const { data } = action.payload;
      const newData = data.map(item => {
        return {
          ...item,
          key: item.entityProducts?.product?.id,
          value: item.entityProducts?.product?.id,
          infoBox: {
            name: item.entityProducts?.product?.name,
            code: item.entityProducts?.product?.code,
            avatar: item.entityProducts?.product?.avatar,
            productOptions: item.entityProducts?.product?.productOptions,
          },
        };
      });

      state.list = newData;
    });
  },
});

const { actions, reducer: productReducer } = productSlice;

export const { reloadCollaboratorProduct } = actions;

export default productReducer;
